import React from 'react'
import PropTypes from 'prop-types'

import Form from 'component/utils/Form'
import Modal from 'component/utils/Modal'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'

import CheckboxAltChecked from 'images/checkbox-alt-checked.svg'
import CheckboxAltUnchecked from 'images/checkbox-alt-unchecked.svg'

const FIELDS = ['idSourceDepositList', 'idDestinationDepositList']

const MissionBlockEditModal = ({
  closeModal,
  depositList,
  fields,
  initialValues,
  setValueToField,
  submit,
  translate,
  values,
}) => {
  const renderOptions = (idDepositList, field, id) => {
    const renderOption = (deposit) => {
      const { idDeposit } = deposit

      const currentValue = values[field]

      const checked = idDepositList.some((depositId) => depositId === idDeposit)

      return (
        <label
          key={idDeposit}
          onClick={() =>
            setValueToField(
              fields[field].input.name,
              checked
                ? currentValue.filter((i) => i !== idDeposit)
                : [...currentValue, idDeposit]
            )
          }
          style={{ display: 'block', margin: '.5rem auto' }}
        >
          <img
            src={checked ? CheckboxAltChecked : CheckboxAltUnchecked}
            className='margin-right'
            style={{ float: 'left', margin: 'auto .5rem' }}
          />
          {`${deposit.idDeposit} - ${deposit.dsDeposit}`}
        </label>
      )
    }

    return (
      <>
        <strong style={{ display: 'block', margin: '1rem auto' }}>
          {translate(`stockTransfer.missionBlock.${id}`)}
        </strong>
        {depositList.map(renderOption)}
      </>
    )
  }

  const isDisabled = () => {
    const initialIdSourceDepositList = initialValues.idSourceDepositList
    const initialIdDestinationDepositList =
      initialValues.idDestinationDepositList

    const currentIdSourceDepositList = values.idSourceDepositList
    const currentIdDestinationDepositList = values.idDestinationDepositList

    const compare = (array1, array2) =>
      array1.length !== array2.length ||
      array1.some((item) => !array2.includes(item))

    return !(
      compare(initialIdSourceDepositList, currentIdSourceDepositList) ||
      compare(initialIdDestinationDepositList, currentIdDestinationDepositList)
    )
  }

  return (
    <Modal
      closeModal={closeModal}
      size='md'
      className='mission-block-edit-modal'
    >
      <h3>
        <strong>{translate('stockTransfer.missionBlock.modal.title')}</strong>
      </h3>
      <p>
        <strong>{initialValues.dsMission}</strong>
      </p>
      <p>
        <strong>{translate('stockTransfer.missionBlock.modal.text')}</strong>
      </p>
      <section style={{ display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
        <div>
          {renderOptions(
            values.idSourceDepositList,
            'idSourceDepositList',
            'source'
          )}
        </div>
        <div>
          {renderOptions(
            values.idDestinationDepositList,
            'idDestinationDepositList',
            'destination'
          )}
        </div>
      </section>
      <Row className='margin-top-quadruple'>
        <Col xs={4} xsOffset={4}>
          <button
            disabled={isDisabled()}
            onClick={() => submit(values)}
            className='button button-primary button-full'
          >
            {translate('save_button_label')}
          </button>
        </Col>
      </Row>
    </Modal>
  )
}

MissionBlockEditModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  depositList: PropTypes.array.isRequired,
  fields: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
  setValueToField: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  translate: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
}

export default Form({ fields: FIELDS })(MissionBlockEditModal)

export { MissionBlockEditModal }
